import { MutationTree } from 'vuex';
import { FunctionsState, Functions } from './functions-types';

export const mutations: MutationTree<FunctionsState> = {
  setFunctionsInState(state, payload: Functions) {
    state.error = false;
    state.functions = payload;
  },
  profileError(state) {
    state.error = true;
    state.functions = undefined;
  },
};
